export default "__VITE_ASSET__CREN8L78__"